/**
 * Runs `handler` every `period` milliseconds for `timeout` milliseconds.
 * @param {number} timeout
 * @param {number} period
 * @param {function} handler
 * @returns {number} `window.setInterval` ID that makes it work. Just use `clearInterval(id)` to stop it.
 */
export default function(timeout, period, handler) {
  let timeLeft = timeout;
  const setIntervalId = setInterval(function () {
    timeLeft -= period;
    if (timeLeft < 0) {
      clearInterval(setIntervalId);
    } else {
      handler();
    }
  }, period);
  return setIntervalId;
}
